import script from "./envView.vue?vue&type=script&lang=ts&setup=true"
export * from "./envView.vue?vue&type=script&lang=ts&setup=true"

import "./envView.vue?vue&type=style&index=0&id=066c280c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066c280c"]])

export default __exports__